import { render } from "./reputacionInmuebles.vue?vue&type=template&id=5a86ac78&scoped=true"
import script from "./reputacionInmuebles.vue?vue&type=script&lang=js"
export * from "./reputacionInmuebles.vue?vue&type=script&lang=js"

import "./reputacionInmuebles.vue?vue&type=style&index=0&id=5a86ac78&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a86ac78"]])

export default __exports__